/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * SlideApprovalIcon - Auto-generated from icon.js
 */
export const SlideApprovalIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path d="M10 18.5H18M3.5 13L13.3595 2.79618C14.4211 1.7346 16.1422 1.7346 17.2038 2.79618C18.2654 3.85776 18.2654 5.57893 17.2038 6.64052L7 16.5L2 18L3.5 13Z" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M12.083 3.75L16.6663 7.57142" stroke="#333333" strokeLinejoin="round" />
	</svg>
);

export default SlideApprovalIcon;
